export default "__VITE_ASSET__BcmmejbD__"